const scrollableButtons = document.querySelectorAll(
	'button[data-action="scroll-down"]' ) as NodeListOf<HTMLButtonElement>;


scrollableButtons.forEach( ( button ) => {
	button.addEventListener( 'click', ( ev ) => {

		window.scrollBy( {
			top: window.innerHeight / 2,
			behavior: 'smooth',
		} );
	} );
} );

